import { render, staticRenderFns } from "./PresetItemCombinationsView.vue?vue&type=template&id=4fca6e2b&"
import script from "./PresetItemCombinationsView.vue?vue&type=script&lang=ts&"
export * from "./PresetItemCombinationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports